import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45version_45check_45global from "/app/middleware/appVersionCheck.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  app_45version_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "analytics-job": () => import("/app/middleware/analyticsJob.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "page-view-tracking": () => import("/app/middleware/pageViewTracking.ts"),
  "shared-link": () => import("/app/middleware/sharedLink.ts")
}